import { render, staticRenderFns } from "./c-footer-load.vue?vue&type=template&id=52bd9b1a&scoped=true"
import script from "./c-footer-load.vue?vue&type=script&lang=js"
export * from "./c-footer-load.vue?vue&type=script&lang=js"
import style0 from "./c-footer-load.vue?vue&type=style&index=0&id=52bd9b1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd9b1a",
  null
  
)

export default component.exports